import React, { Component } from 'react';
import './Connect.css';
import { NavItem, NavLink, Nav } from 'reactstrap';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { env } from '../../environment';

class Connect extends Component {

    constructor(props){
        super(props);
        this.state ={
            userType : "",
            purpose : "",  
            userName : "",
            email : "",
            contactNumber : "",
            message : "",
            showMessage : false
        }
    }

    componentDidMount() {
        document.title = 'Connect';
    }

    handleSubmit(e){
        e.preventDefault();
        axios.post( env + `user/save`,{type: this.state.userType, purpose: this.state.purpose, name: this.state.userName, email: this.state.email, contactNumber : this.state.contactNumber, message : this.state.message})
            .then(res => {
                console.log("user added successfully");
                this.setState({ showMessage : true})
                setTimeout(() => { this.setState({ 
                    userType : "",
                    purpose : "",
                    userName : "",
                    email : "",
                    contactNumber : "",
                    message : "",
                    showMessage : false,
                    }) ;
                    this.props.history.push("/login");
                }, 2000);
            })
    }

    render () {
          return (
            <div>
              <div> 
                    <NavLink style={{position:'fixed', fontSize:'30px', padding:'15px 30px', color:'white', width:'100%', background: '#333F50'}} tag={Link} to={'/login'}>
                                                swipequotes
                                                </NavLink>
                </div>
            <div className="connectContainer">
            <form className="connect-card" onSubmit={(e) => this.handleSubmit(e)}>
                <h1>Connect with Us</h1>
                <p className="radio-title">Who are you?</p>
                <div className="radio-row">
                <label><input type="radio" name="userType" onChange={() => this.setState({ userType: "Company" })} /> Company</label>
                <label><input type="radio" name="userType" onChange={() => this.setState({ userType: "Firm" })} /> Firm</label>
                <label><input type="radio" name="userType" onChange={() => this.setState({ userType: "Individual" })} /> Individual</label>
                </div>

                <p className="radio-title">I would like to</p>
                <div className="radio-row">
                <label><input type="radio" name="purpose" className="radio-item" onChange={() => this.setState({ purpose: "Advertise" })}  style={{width:'15px'}}/> Advertise</label>
                <label><input type="radio" name="purpose" className="radio-item" onChange={() => this.setState({ purpose: "Publish" })} style={{width:'15px'}}/> Publish My Content</label>
                </div>

                <div className="form-group">
                <label>Name</label>
                <input type="text" placeholder="Name" onChange= {(e) => this.setState({userName : e.target.value})} />
                </div>

                <div className="form-group">
                <label>Email</label>
                <input type="email" placeholder="Email" onChange= {(e) => this.setState({email : e.target.value})} />
                </div>

                <div className="form-group">
                <label>Contact Number (Whatsapp No.)</label>
                <input type="number"  placeholder="Contact Number" onChange= {(e) => this.setState({contactNumber : e.target.value})} />
                </div>

                <div className="form-group">
                <label>Message</label>
                <textarea placeholder="Write your message..." onChange= {(e) => this.setState({message : e.target.value})} />
                </div>

                <button className="submit-btn" disabled={ this.state.userType.trim() === "" || this.state.purpose.trim() === "" || this.state.userName.trim() === "" || this.state.email.trim() === "" || this.state.contactNumber.trim() === ""  }>Send</button>
                <div className={this.state.showMessage ? 'showMessage' : 'hideMessage'}>
                    We usually respond in a few hours ...
                </div>
            </form>
            
          </div>
          <div className='connectFooter'>
                    <Nav horizontal className="list-unstyled pb-3">
                        <NavItem>
                            <NavLink tag={Link} to={'/login'}>
                            Home
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink tag={Link} to={'/aboutUs'}>
                            About Us
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink tag={Link} to={'/termsOfService'}>
                            Terms of Service
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink tag={Link} to={'/privacyPolicy'}>
                            Privacy & Content Policy
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink tag={Link} to={'/questions'}>
                            Have Questions ?
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink tag={Link} to={'/connect'}>
                            Connect with Us
                            </NavLink>
                        </NavItem>
                    </Nav>
                </div>
          </div>
            
          )
    }
  }
  
  export default Connect